import { render, staticRenderFns } from "./WindowType.vue?vue&type=template&id=ffc788dc&scoped=true"
import script from "./WindowType.vue?vue&type=script&lang=ts"
export * from "./WindowType.vue?vue&type=script&lang=ts"
import style0 from "./WindowType.vue?vue&type=style&index=0&id=ffc788dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc788dc",
  null
  
)

export default component.exports